import HomeAppStoreButton from "../../buttons/homeScreen/HomeAppStoreButton";
import HomePlayStoreButton from "../../buttons/homeScreen/HomePlayStoreButton";
import HomePhoneImage from "../../images/homeScreen/HomePhoneImage";
import HomeDownloadMobileAppTexts from "../../texts/homeScreen/HomeDownloadMobileAppTexts";

export default function HomeDownloadMobileApp() {
    // Used in

    // BUILD
    return (
        <div className={"bg-backgroundLight3 w-full flex flex-col justify-center items-center py-[72px]"}>
            <div className={"w-full max-w-[1200px] flex flex-col lg:hidden justify-start items-start space-y-[48px] px-[32px]"}>
                <div className={"min-w-[520px] w-[560px] h-[280px] min-h-[240px] flex flex-col justify-between items-start"}>
                    <HomeDownloadMobileAppTexts />
                    <div className={"flex justify-center items-center space-x-[16px]"}>
                        <HomeAppStoreButton />
                        <HomePlayStoreButton />
                    </div>
                </div>
                <HomePhoneImage />
            </div>
            <div className={"w-full max-w-[1200px] hidden lg:flex justify-between items-start px-[32px] lg:px-[48px]"}>
                <HomePhoneImage />
                <div className={"min-w-[520px] w-[560px] h-[280px] min-h-[240px] flex flex-col justify-between items-start"}>
                    <HomeDownloadMobileAppTexts />
                    <div className={"flex justify-center items-center space-x-[16px]"}>
                        <HomeAppStoreButton />
                        <HomePlayStoreButton />
                    </div>
                </div>
            </div>
        </div>
    );
}